const root = document.querySelector(':root');
const rgbToHex = (r: number, g: number, b: number) => `${[r, g, b].map(x => x.toString(16).padStart(2, '0')).join('')}`;

export const UIavatarFromText = (value: string) => {
  let UIavatar = `https://ui-avatars.com/api/?background=7367f0&name=${value}&color=ffffff`;

  if (root) {
    const computed = getComputedStyle(root);
    if (computed) {
      const primary = computed.getPropertyValue('--v-theme-primary');
      if (primary) {
        const rgb = primary.split(',');

        UIavatar = `https://ui-avatars.com/api/?background=${rgbToHex(Number(rgb[0]), Number(rgb[1]), Number(rgb[2]))}&name=${value}&color=ffffff`;
      }
    }
  }

  return UIavatar;
};

export const UIcolorVariants = () => {
  const distinctDeepVibrantColors = [
    '#D72638', // Strong Red
    '#F97316', // Vivid Orange
    '#FACC15', // Bold Yellow
    '#65A30D', // Vibrant Olive Green
    '#059669', // Emerald Green
    '#0D9488', // Teal
    '#2563EB', // Bright Blue
    '#1E40AF', // Royal Blue
    '#7C3AED', // Strong Purple
    '#9333EA', // Violet
    '#C026D3', // Magenta
    '#DB2777', // Deep Pink
    '#E11D48', // Crimson Rose
    '#14B8A6', // Turquoise
    '#F59E0B' // Amber
  ];

  return distinctDeepVibrantColors[Math.floor(Math.random() * distinctDeepVibrantColors.length)];
};

export const getOperationColor = (operation: string) => {
  const op = operation?.toUpperCase?.() || '';

  const colorMap: Record<string, string> = {
    CREATE: 'success',
    UPDATE: 'info',
    DELETE: 'error',
    CANCEL: 'error',
    APPROVE: 'success',
    REJECT: 'error',
    PUBLISH: 'success',
    UNPUBLISH: 'error',
    UPLOAD: 'primary',
    APPOINTMENT_ASSIGNED: 'primary',
    APPOINTMENT_UNASSIGNED: 'secondary',
    RESET: 'warning'
  };

  return colorMap[op] || 'primary';
};

/**
 * Money shown to 2 decimals. Charge/pay amounts are stored unrounded (4dp, e.g. 13.6050) so totals round once —
 * screens show them to the penny. Non-numeric values (e.g. the '–' placeholder) are returned as is.
 */
export const formatAmount = (value: number | string | null | undefined): string => {
  if (value === null || value === undefined || value === '') return '–';
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value);

  return (Math.round(Number((n * 100).toPrecision(15))) / 100).toFixed(2);
};

// Whole-day count from a number or numeric string; null for anything else (missing expiry date, '', NaN)
const toDayCount = (value: unknown): number | null => {
  const days = typeof value === 'string' && value.trim() !== '' ? Number(value) : value;

  return typeof days === 'number' && Number.isFinite(days) ? days : null;
};

/**
 * Docezy's daysLeft is expiry date minus today: negative once a document has expired. The number stays raw for
 * sorting; this is the readable text shown in the table and written to the export.
 */
export const formatDaysUntilExpiry = (value: unknown): string => {
  const days = toDayCount(value);

  if (days === null) {
    return '—';
  }

  if (days === 0) {
    return 'Expires today';
  }

  const count = Math.abs(days);
  const unit = count === 1 ? 'day' : 'days';

  return days < 0 ? `Expired ${count} ${unit} ago` : `${count} ${unit}`;
};

export const daysUntilExpiryColor = (value: unknown): string => {
  const days = toDayCount(value);

  if (days === null) {
    return 'secondary';
  }

  if (days < 0) {
    return 'error';
  }

  if (days <= 30) {
    return 'warning';
  }

  return 'info';
};
